export const SPACING = 20;
export const LAYOUT_TYPES = {
  ONE_COLUMN: '1-column',
  TWO_COLUMN: '2-columns',
};
export const COMPLETED_TYPES = ['completed', 'disqualified'];
export const AVAILABLE_TYPES = ['in_progress', 'available', 'stale'];
export const VISIBLE_TYPES = ['visible'];
export const RECONSENT_REQUIRED = 'reconsent_required';
